import { render, staticRenderFns } from "./UiTwoFactor.vue?vue&type=template&id=d86f67ee&lang=pug&"
import script from "./UiTwoFactor.vue?vue&type=script&lang=js&"
export * from "./UiTwoFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports